import { createSlice } from "@reduxjs/toolkit";

import {} from "./actions";
import {
  getCustomerId,
  updateCustomer,
  getCountries,
  getStates,
  getCities
} from "../actions";

const initialState = {
  loadedFirstTime: false,
  loading: false,
  user: {},
  userRequested: false,
  userObtained: false,
  countries:[],
  countriesRequested: false,
  countriesObtained: false,
  states:[],
  statesRequested: false,
  cities:[],
  citiesRequested: false
};

const myAccountSlice = createSlice({
  name: "myAccount",
  initialState: initialState,
  reducers: {
    resetmyAccount: () => initialState
  },
  extraReducers: (builder) => {
    builder.addCase(getCustomerId.fulfilled, (state, action) => {
      state.user = action.payload.success ? action.payload.data.customer : {};
      state.userObtained = action.payload.success ? true : false
    });
    builder.addCase(getCustomerId.pending, (state) => {
      state.userRequested = true;
    });
    builder.addCase(getCustomerId.rejected, (state) => {});

    builder.addCase(updateCustomer.fulfilled, (state, action) => {
      state.loading = false;
      state.user = action.payload.success ? action.payload.data.customer : {};
    });
    builder.addCase(updateCustomer.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(updateCustomer.rejected, (state) => {
      state.loading = false;
    })

    builder.addCase(getCountries.pending, (state) => {
      state.countriesRequested = true
    })
    builder.addCase(getCountries.fulfilled, (state, action) => {
      state.countriesObtained = action.payload.success ? true : false;
      state.countries = action.payload.success ? action.payload.data : [];
    })
    builder.addCase(getCountries.rejected, (state, action) => {
    })

    builder.addCase(getStates.pending, (state) => {
      state.statesRequested = true;
    })
    builder.addCase(getStates.fulfilled, (state, action) => {
      state.states = action.payload.success ? action.payload.data : [];
      state.statesRequested = false;
    })
    builder.addCase(getStates.rejected, (state) => {
      state.statesRequested = false;
    })

    builder.addCase(getCities.pending, (state) => {
      state.citiesRequested = true;
    })
    builder.addCase(getCities.fulfilled, (state, action) => {
      state.cities = action.payload.success ? action.payload.data : [];
      state.citiesRequested = false;
    })
    builder.addCase(getCities.rejected, (state, action) => {
      state.citiesRequested = false;
    })
  }
})

export const { resetmyAccount } = myAccountSlice.actions;
export default myAccountSlice.reducer;